<div class="dialog-container">
    <h2 mat-dialog-title>ASN hochladen</h2>

    <mat-dialog-content>
        <form [formGroup]="asnForm">
            <mat-form-field
                appearance="outline"
                class="field-quarter">
                <mat-label>OrganisationSiteKey</mat-label>
                <input
                    matInput
                    formControlName="organizationSiteKey" />
                @if (
                    asnForm.get('organizationSiteKey')?.hasError('required') &&
                    asnForm.get('organizationSiteKey')?.touched
                ) {
                    <mat-error> OrganisationSiteKey wird benötigt </mat-error>
                }
            </mat-form-field>
            <div formArrayName="items">
                @for (
                    itemGroup of itemsArray.controls;
                    let i = $index;
                    track itemGroup
                ) {
                    <div
                        [formGroupName]="i"
                        class="item-section">
                        <div class="item-header">
                            <h3>ASN Artikel {{ i + 1 }}</h3>
                            @if (itemsArray.length > 1) {
                                <button
                                    type="button"
                                    mat-icon-button
                                    (click)="removeItem(i)"
                                    class="remove-button">
                                    <mat-icon
                                        fontSet="material-symbols-outlined"
                                        >close</mat-icon
                                    >
                                </button>
                            }
                        </div>

                        <div class="item-fields">
                            <mat-form-field
                                appearance="outline"
                                class="field-quarter">
                                <mat-label
                                    [matTooltip]="
                                        'Eindeutige ASN-Referenznummer'
                                    ">
                                    ASN
                                </mat-label>
                                <input
                                    matInput
                                    formControlName="advancedShippingNotice" />
                                @if (
                                    itemGroup
                                        .get('advancedShippingNotice')
                                        ?.hasError('required') &&
                                    itemGroup.get('advancedShippingNotice')
                                        ?.touched
                                ) {
                                    <mat-error> ASN wird benötigt </mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field
                                appearance="outline"
                                class="field-quarter">
                                <mat-label
                                    [matTooltip]="
                                        'Bestellnummer / articleOrderNumber'
                                    ">
                                    PO Nummer
                                </mat-label>
                                <input
                                    matInput
                                    formControlName="articleOrderNumber" />
                                @if (
                                    itemGroup
                                        .get('articleOrderNumber')
                                        ?.hasError('required') &&
                                    itemGroup.get('articleOrderNumber')?.touched
                                ) {
                                    <mat-error>
                                        PO Nummer wird benötigt
                                    </mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field
                                appearance="outline"
                                class="field-quarter">
                                <mat-label
                                    [matTooltip]="
                                        'item code / consigneeOrderNumber'
                                    ">
                                    Artikel-Nr. Empfänger
                                </mat-label>
                                <input
                                    matInput
                                    formControlName="consigneeOrderNumber" />
                            </mat-form-field>

                            <mat-form-field
                                appearance="outline"
                                class="field-quarter">
                                <mat-label>Beschreibung</mat-label>
                                <input
                                    matInput
                                    formControlName="description" />
                            </mat-form-field>

                            <mat-form-field
                                appearance="outline"
                                class="field-quarter">
                                <mat-label>Menge</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    min="1"
                                    formControlName="quantity"
                                    placeholder="1" />
                                @if (
                                    itemGroup
                                        .get('quantity')
                                        ?.hasError('required') &&
                                    itemGroup.get('quantity')?.touched
                                ) {
                                    <mat-error>Menge wird benötigt</mat-error>
                                }
                                @if (
                                    asnForm
                                        .get('items')
                                        ?.get('' + i)
                                        ?.get('quantity')
                                        ?.hasError('min') &&
                                    asnForm
                                        .get('items')
                                        ?.get('' + i)
                                        ?.get('quantity')?.touched
                                ) {
                                    <mat-error
                                        >Menge muss mindestens 1 sein</mat-error
                                    >
                                }
                            </mat-form-field>

                            <mat-form-field
                                appearance="outline"
                                class="field-quarter">
                                <mat-label
                                    [matTooltip]="
                                        'Verkaufsfähiger Code / sellableCode'
                                    ">
                                    Verkaufsfähiger Code
                                </mat-label>
                                <input
                                    matInput
                                    formControlName="sellableCode" />
                                @if (
                                    asnForm
                                        .get('items')
                                        ?.get('' + i)
                                        ?.get('sellableCode')
                                        ?.hasError('required') &&
                                    asnForm
                                        .get('items')
                                        ?.get('' + i)
                                        ?.get('sellableCode')?.touched
                                ) {
                                    <mat-error
                                        >Verkaufsfähiger Code wird
                                        benötigt</mat-error
                                    >
                                }
                            </mat-form-field>

                            <mat-form-field
                                appearance="outline"
                                class="field-quarter">
                                <mat-label
                                    [matTooltip]="
                                        'Lagerplatzbezeichnung / storageLocation'
                                    ">
                                    Lagerort
                                </mat-label>
                                <input
                                    matInput
                                    formControlName="storageLocation" />
                            </mat-form-field>
                        </div>
                    </div>
                }
            </div>

            <button
                type="button"
                mat-stroked-button
                (click)="addItem()"
                class="add-item-button">
                <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
                Weiteres ASN Artikel
            </button>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button
            mat-stroked-button
            (click)="onCancel()">
            Abbrechen
        </button>
        <button
            mat-flat-button
            color="primary"
            (click)="onSubmit()">
            ASN aktualisieren
        </button>
    </mat-dialog-actions>
</div>
